import React, { useState } from "react";
import * as BosIdentityServices from "data/BosWebServices/BosIdentityServices";
import LoginHeader from "./LoginHeader";
import { getTranslation as translate } from "logic/LocaleManager";

import { LOGINTYPE_REGISTER_NEWUSER } from "pages/Login/LoginPage";

// DevExtreme components
import TextBox from 'devextreme-react/text-box';
import ValidationGroup from 'devextreme-react/validation-group';
import Validator, { RequiredRule } from 'devextreme-react/validator';
import Button from 'devextreme-react/button';

// Redux
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as bosUserActions from "../../redux/actions/bosUserActions";

function RegisterNewUser(props) {
  const { actionSuccessfull, actionError, cleanMessages, setIsLoading, isLoading, targetUri } = props;
  const registerFailedText = translate("registerNewUser.failed", "Register failed!");

  const [username, setUsername] = useState("");

  const loginChanged = e => {
    setUsername(e.value);
    cleanMessages("");
  };

  async function register(args) {
    if (!args.validationGroup.validate().isValid) return;
    await registerInternal(username);
    args.validationGroup.reset();
  }

  async function registerInternal(usr) {
    try {
      setIsLoading(true);
      let result = await BosIdentityServices.fetchRegisterNewUser(usr, targetUri);
      if (!result || !result.token) throw new Error("NO TOKEN RECEIVED");
      props.bosUserActions.setBosUser({
        newDisplayName: usr,
        newAuthToken: result.token,
        newPersistIn: "local"
      });
      actionSuccessfull(LOGINTYPE_REGISTER_NEWUSER, result.startUri, null, result.enableLaunchpad);
    } catch (error) {
      props.bosUserActions.clearBosUser();
      actionError(registerFailedText + " (" + error + ")");
      setIsLoading(false);
    }
  }

  return (
    <ValidationGroup>
      <LoginHeader title={translate("registerNewUser.title", "Register")} description={translate("registerNewUser.description", "Register your email address")} />
      <div className={'dx-field'}>
        <TextBox
          value={username}
          onValueChanged={loginChanged}
          placeholder={translate("registerNewUser.textBoxEmailLabel", "Email")}
          disabled={isLoading}
          width={'100%'}
        >
          <Validator>
            <RequiredRule message={translate("registerNewUser.textBoxEmailError", "Email is required")} />
          </Validator>
        </TextBox>
      </div>
      <div className={'dx-field'}>
        <Button
          type={'default'}
          text={translate("registerNewUser.action", "Register")}
          onClick={register}
          disabled={isLoading}
          width={'100%'}
        />
      </div>
    </ValidationGroup>
  );
}

function mapDispatchToProps(dispatch) {
  return {
    bosUserActions: bindActionCreators(bosUserActions, dispatch)
  };
}

export default connect(
  null,
  mapDispatchToProps
)(RegisterNewUser);
